import { Text, Stack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { participateConversationComponentIsVisible } from '../../../../utils';

interface RecommendationDetailsProps {}

export const RecommendationDetails: React.FC<RecommendationDetailsProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text fontSize={Typography['fontsize.lg']} variant="semibold">
        Detalhes da recomendação
      </Text>
      <Box bg="neutral.lightest" h="0.5px" />
      <Stack
        direction={{ base: 'column', sm: 'row' }}
        alignItems="center"
        {...(isMobile && { space: Spacing['stack.nano'] })}
        justifyContent="space-between">
        {participateConversationComponentIsVisible && (
          <Stack
            direction={{ base: 'row', sm: 'column' }}
            space={Spacing['stack.quarck']}
            {...(isMobile && {
              w: 'full',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}>
            <Text
              fontSize={Typography['fontsize.md']}
              color={{ base: 'neutral.dark', sm: 'neutral.black' }}
              variant={{ base: 'regular', sm: 'semibold' }}>
              Conversa com especialista
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
              Sim, quero participar
            </Text>
          </Stack>
        )}
        <Stack
          direction={{ base: 'column', sm: 'row' }}
          alignItems="center"
          space={{ base: Spacing['stack.nano'], sm: Spacing['inline.xxxs'] }}
          {...(isMobile && { w: 'full' })}
          {...(!participateConversationComponentIsVisible && {
            w: 'full',
            justifyContent: 'space-between',
          })}>
          <Stack
            direction={{ base: 'row', sm: 'column' }}
            {...(isMobile && {
              w: 'full',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}
            space={Spacing['stack.quarck']}
            {...(!isMobile &&
              participateConversationComponentIsVisible && {
                alignItems: 'flex-end',
              })}>
            <Text
              fontSize={Typography['fontsize.md']}
              color={{ base: 'neutral.dark', sm: 'neutral.black' }}
              variant={{ base: 'regular', sm: 'semibold' }}>
              Canal de envio
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
              Whatsapp
            </Text>
          </Stack>
          <Stack
            direction={{ base: 'row', sm: 'column' }}
            {...(isMobile && {
              w: 'full',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}
            space={Spacing['stack.quarck']}
            {...(!isMobile && { alignItems: 'flex-end' })}>
            <Text
              fontSize={Typography['fontsize.md']}
              color={{ base: 'neutral.dark', sm: 'neutral.black' }}
              variant={{ base: 'regular', sm: 'semibold' }}>
              Hora/data de Envio
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
              00:00:00 - 00/00/0000
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </VStack>
  );
};
